import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';

import { FILE_TYPES } from '../../../../constants';
import { displayError } from '../../../../helpers';
import { validateFileFormat } from '../../../../validations';
import { convertToBase64 } from '../../../../helpers/CropImage';
import { BankDetailsCard, Dropdown, MixPanelTrackedLink, UploadImage, ValidationError } from '../../../../components';

export default function ({ state, handleChange, validationErrors }) {
    const bankSlipUploadRef = useRef();

    const countryBanks = useSelector(state => state.banks_list.banks_list);

    const setBankSlip = async (event) => {
        let newImage = event.target.files[0];
        const validFormat = validateFileFormat(FILE_TYPES.BANK_SLIP, newImage.type);
        if (validFormat) {
            const base64 = await convertToBase64(newImage);

            handleChange({
                target: {
                    name: 'bankSlip',
                    value: { attachment: base64, name: newImage.type == 'application/pdf' ? newImage.name : undefined }
                }
            })
        }
        else if (!validFormat && state.selectedPaymentMethodDetails?.bankSlip)
            handleChange({
                target: {
                    name: 'bankSlip',
                    value: { attachment: null }
                }
            })
    }
    return <Box className="BankTransfer">
        <Dropdown
            id="selectedBank"
            name="selectedBank"
            label="Select a bank where you will transfer your donation *"
            value={state.selectedBank.bank_id}
            options={countryBanks}
            onChange={handleChange}
            error={displayError(validationErrors.paymentMethodDetails?.bank)}
            helperText={validationErrors.paymentMethodDetails?.bank}
            fullWidth
            autoComplete
        />
        {
            state.selectedBank.bank_id ? <React.Fragment>
                <BankDetailsCard bankDetails={state.selectedBank.bank_details} />
                <Typography sx={{ fontSize: '13px' }}>Please transfer your amount to the selected bank account, take a screenshot of transaction as evidence and attach it to your donation by clicking on the <b>Upload screenshot</b> button below to complete your donation.</Typography>
                <MixPanelTrackedLink
                    type="button"
                    label="Upload Bank Slip"
                    context="Upload Bank Slip"
                    variant="contained"
                    error={displayError(validationErrors?.paymentMethodDetails?.bank)}
                    helpertext={validationErrors.paymentMethodDetails?.bank}
                    onClick={() => bankSlipUploadRef.current.click()}
                    fullWidth
                >
                    Upload Screenshot
                </MixPanelTrackedLink>

                {
                    validationErrors.paymentMethodDetails?.bankSlip &&
                    <ValidationError message={validationErrors.paymentMethodDetails.bankSlip} />
                }

                {
                    state.bankSlip.attachment &&
                    <React.Fragment>
                        {
                            state.bankSlip.name ? <p>{state.bankSlip.name}</p>
                                : <img
                                    src={state.bankSlip.attachment}
                                    alt="Bank Slip"
                                    style={{
                                        borderRadius: '15px',
                                        width: '100%'
                                    }}
                                />
                        }
                    </React.Fragment>
                }
            </React.Fragment> :
                null
        }
        <UploadImage ref={bankSlipUploadRef} handleUpload={setBankSlip} />
    </Box>
}